import { render, staticRenderFns } from "./DayOfManyClassDialog.vue?vue&type=template&id=0457fec6&scoped=true"
import script from "./DayOfManyClassDialog.vue?vue&type=script&lang=js"
export * from "./DayOfManyClassDialog.vue?vue&type=script&lang=js"
import style0 from "./DayOfManyClassDialog.vue?vue&type=style&index=0&id=0457fec6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0457fec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0457fec6')) {
      api.createRecord('0457fec6', component.options)
    } else {
      api.reload('0457fec6', component.options)
    }
    module.hot.accept("./DayOfManyClassDialog.vue?vue&type=template&id=0457fec6&scoped=true", function () {
      api.rerender('0457fec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/DayOfManyClassDialog.vue"
export default component.exports